import { useEffect, useRef } from 'react';
import { useStore } from 'ra-core';

export const useExpandSignificantRows = (resource, records) => {
    const [, setExpandedIds] = useStore(resource ? `${resource}.datagrid.expanded` : 'parameter.datagrid.expanded', []);
    const processedIdsRef = useRef(new Set());

    useEffect(() => {
        if (!resource || !Array.isArray(records) || records.length === 0) {
            return;
        }

        const significantIds = records
            .filter(record => Boolean(record?.isSignificant) && record?.id != null && !processedIdsRef.current.has(record.id))
            .map(record => record.id);

        if (significantIds.length === 0) {
            return;
        }

        significantIds.forEach(id => processedIdsRef.current.add(id));

        setExpandedIds(current => {
            const currentIds = Array.isArray(current) ? current : [];
            const missingIds = significantIds.filter(id => !currentIds.includes(id));

            if (missingIds.length === 0) {
                return currentIds;
            }

            return [...currentIds, ...missingIds];
        });
    }, [records, resource, setExpandedIds]);
};
